import { baseUrl } from './routes';

export class NotesRoutes {
  static get base(): string {
    return `${baseUrl}/notes-list`;
  }

  static get view(): string {
    return NotesRoutes.base;
  }

  static get parentView(): string {
    return `parent`;
  }
}
